import { Component, ViewEncapsulation } from '@angular/core';


@Component({
    selector: 'docs-app',
    templateUrl: './docs.component.html',
    styleUrls: ['./docs.scss'],
    encapsulation: ViewEncapsulation.None
})
export class DocsComponent {

}
